import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=67546d2b&scoped=true"
import script from "./AppBase.vue?vue&type=script&lang=js"
export * from "./AppBase.vue?vue&type=script&lang=js"
import style0 from "./AppBase.vue?vue&type=style&index=0&id=67546d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67546d2b",
  null
  
)

export default component.exports